module.exports = __webpack_public_path__ + "static/media/landing.a1b2e72f.jpg";